import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Grouping Behaviors',
  content: `
Grouping behavior in Pliable determines how records are processed, combined, or aggregated during data preparation. These options allow for fine-tuned control over how data is treated based on business or analysis requirements.

# How to Configure Grouping Behavior

1. Start a new cleaning step by clicking on **"Start Cleaning"** from the data source node screen, or navigate to an existing cleaning step.

2. Locate the **"Grouping Behavior"** dropdown menu.

3. Select the desired grouping option:
   - **No Grouping**: Leaves records as-is.
   - **Merge**: Choose the columns to define a match and merge.
   - **Summarize**: Specify the grouping criteria and select aggregation functions.
   - **Identify**: Specify the columns to check for common attributes.

4. Preview the output to ensure the grouping behavior meets your requirements.

# Grouping Behaviors

# Detailed Behavior

### 1. No Grouping

- **Use Case**: When each record needs to remain distinct and no grouping or merging logic is required.
- **Example**: Exporting transactional data where every row represents a single event or activity.

### 2. Merge

- **Use Case**: Consolidates duplicate records or records that share a key column. Helps clean data by eliminating redundancies.
- **Logic**:
  - Matches records based on specified criteria (e.g., primary key or unique identifier).
  - Combines the data into a single record.
- **Example**: Merging customer records with the same email address.

### 3. Summarize

- **Use Case**: Groups records based on one or more columns and applies aggregation methods (e.g., SUM, AVG, MAX).
- **Logic**:
  - Records are grouped by the specified key(s).
  - Metrics are aggregated based on selected columns and functions.
- **Example**: Summing total revenue by region or calculating average order value by customer segment.

### 4. Identify

- **Use Case**: Flags records that share common attributes but does not modify or merge them. Often used for data quality checks.
- **Logic**:
  - Records are grouped and evaluated to highlight commonalities without changing the underlying data.
- **Example**: Identifying duplicate email addresses in a contact list.
`,
};

export default doc;
